import { OutlinedInputProps } from '@mui/material/OutlinedInput';

import { TypographyColors, TypographyVariants } from '../Typography/types';

export type InputShape = 'pill' | 'square';

export type InputSize = 'large' | 'medium';

export type InputAppearance = 'filled' | 'outline';

export enum InputAdornmentEnum {
  Both = 'both',
  End = 'end',
  None = 'none',
  Start = 'start',
}
export interface InputProps extends Omit<OutlinedInputProps, 'classes' | 'color' | 'size'> {
  appearance?: InputAppearance;
  characterLimit?: number;
  color?: TypographyColors;
  onChangeText?: (text: string) => void;
  shape?: InputShape;
  size?: InputSize;
  variant?: TypographyVariants;
}
